
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticClass:"i-fill",attrs:{"fill":"#D0EFEC"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"m18.375 21.625 2.25-2.25 7.071 7.071-2.25 2.25zm-4.5 4.5 2.25-2.25 7.071 7.071-2.25 2.25zm-4.5 4.5 2.25-2.25 7.071 7.071-2.25 2.25z","clip-rule":"evenodd"}}),_c('path',{attrs:{"d":"M43 5H11l32 32z"}})]),_c('path',{staticClass:"i-Rectangle 36",attrs:{"stroke":"#234652","d":"M21 12H6v30h30V27"}}),_c('path',{staticClass:"i-Rectangle 37",attrs:{"stroke":"#234652","d":"M39 22V9H26"}}),_c('path',{staticClass:"i-Line 32",attrs:{"stroke":"#234652","d":"M39 9.042 21.898 26.144"}})])
          )
        }
      }
    